<template>
  <div class="ask-messages-list">
    <AskMessage
      v-for="(message, i) in conversation.messages"
      :key="i"
      :message="message"
    />

    <AskMessage
      v-if="conversation.streamingMessage?.text"
      :message="conversation.streamingMessage"
      format="markdown"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useChatStore } from '@frontend/ui/stores/chatStore';

import AskMessage from './AskMessage.vue';

const chatStore = useChatStore();

const conversation = computed(() => chatStore.conversations[chatStore.currentConversationId] ?? { messages: [], streamingMessage: { text: '' } });
</script>

<style scoped>
.ask-messages-list {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
</style>
